import { render, staticRenderFns } from "./ClientSubCategory.vue?vue&type=template&id=886ea30e&scoped=true&"
import script from "./ClientSubCategory.vue?vue&type=script&lang=js&"
export * from "./ClientSubCategory.vue?vue&type=script&lang=js&"
import style0 from "./ClientSubCategory.vue?vue&type=style&index=0&id=886ea30e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886ea30e",
  null
  
)

export default component.exports